import { z } from "zod";

function preprocessNumber(value: unknown) {
	if (Number.isNaN(Number(value))) return null;
	return value;
}

export const ZodNumberNullable = z.preprocess(
	preprocessNumber,
	z.number().nullable().default(null),
) as unknown as z.ZodNumber;
export const ZodNumberPositiveNullable = z.preprocess(
	preprocessNumber,
	z.number().min(0).nullable().default(null),
) as unknown as z.ZodNumber;
